import { Outlet, useNavigate } from 'react-router-dom';
import SideNavBar from '../SideNavBar';
import TopNavBar from '../TopNavBar';
import { useAuth } from '../../context/AuthContext';

const AppLayout = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  const handleLogout = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <div className="app-shell">
      <SideNavBar />
      <div className="main-content">
        <TopNavBar onLogout={handleLogout} />
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
